/*
    Init project styles
*/
import '../style.scss';

import MegaMenu from './modules/megaMenu.module';
import TreeListModule from './modules/treeList.module';

const megaMenu = new MegaMenu();
const treeList = new TreeListModule();